"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = errorManager;
exports.isValidationError = void 0;

var _Errors = require("./Errors");

var _errToJSON = _interopRequireDefault(require("./utils/errToJSON"));

var _paths = require("./utils/paths");

var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function trimChildren(rootPath, errors) {
  let result = {};
  Object.keys(errors).forEach(path => {
    if (rootPath !== path && (0, _paths.inPath)(rootPath, path)) return;
    result[path] = errors[path];
  });
  return result;
}

function reduce(paths) {
  paths = (0, _uniqBy.default)(paths, p => p.path);
  if (paths.length <= 1) return paths;
  return paths.reduce((innerPaths, current) => {
    innerPaths = innerPaths.filter(p => !(0, _paths.inPath)(current.path, p.path));
    if (!innerPaths.some(p => (0, _paths.inPath)(p.path, current.path))) innerPaths.push(current);
    return innerPaths;
  }, []);
}

let isValidationError = err => err && err.name === 'ValidationError';

exports.isValidationError = isValidationError;

function errorManager(handleValidation) {
  return {
    async collect(paths, pristineErrors = _Errors.EMPTY_ERRORS, options) {
      const specs = reduce(paths.map(p => typeof p === 'string' ? {
        path: p,
        shallow: false
      } : p));

      let errors = _objectSpread({}, pristineErrors);

      let nextErrors = errors;
      let workDone = false;
      specs.forEach(({
        path,
        shallow
      }) => {
        nextErrors = (0, _paths.trim)(path, nextErrors, shallow);
        if (errors !== nextErrors) workDone = true;
      });
      let validations = specs.map(spec => Promise.resolve(handleValidation(spec, options)).then(validationError => {
        if (!validationError) return true;
        if (!isValidationError(validationError)) throw validationError;

        if (!spec.shallow) {
          (0, _errToJSON.default)(validationError, nextErrors);
          return;
        }

        const fieldErrors = (0, _errToJSON.default)(validationError);
        Object.assign(nextErrors, trimChildren(spec.path, fieldErrors));
      }));
      const results = await Promise.all(validations);
      if (!workDone && results.every(Boolean)) return pristineErrors;
      return nextErrors;
    }

  };
}